// extracted by mini-css-extract-plugin
export default {"Workspaces":"_Workspaces--qzSw3","ContentHeader":"_ContentHeader--JnUoz","EmptyStateHeader":"_EmptyStateHeader--m2txr"};